export const TELEGRAM_STAR_COLOR = '#FFAC33';
